export const fromJsonToQueryString = (data = {}) => {
    const query = [];
    for (const [key, value] of Object.entries(data)) {
        query.push(`${key}=${value}`);
    }
    return query.join('&');
};
